import React from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../../../Common/withRouter'
import { Col } from 'reactstrap'

// Import conditionnel du logo avec gestion d'erreur
let logo = null
try {
  logo = require('./logo.png')
} catch (e) {
  console.warn('Logo non trouvé:', e.message)
}

const GeneralCashierContent = (props) => {
  // Debug complet au montage du composant
  React.useEffect(() => {
    console.log('=== DEBUG GeneralCashierContent ===')
    console.log('Props:', props)
    console.log('Section:', props.section)
    console.log('Sale:', props.sale)
    console.log('Items:', props.items)
    console.log('Total Amount:', props.totalAmount)
    console.log('Amount Received:', props.amountRecieved)
    console.log('===================================')
  }, [])

  // Fonction t() sécurisée
  const t = (key) => {
    try {
      return props.t ? props.t(key) : key
    } catch (e) {
      console.error('Erreur traduction:', key, e)
      return key
    }
  }

  // Rendu avec gestion d'erreur globale
  try {
    return (
      <div className="gen-lab-rep-print p-3">
        {/* Styles intégrés */}
        <style>
          {`
            .gen-lab-rep-print {
              font-family: 'Courier New', Courier, monospace;
              font-size: 12px;
              background: white;
              max-width: 100%;
              overflow: hidden;
            }
            .header-flex {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 5px;
            }
            .header-logo {
              display: flex;
              justify-content: center;
              flex-grow: 1;
            }
            .header-logo img {
              height: 60px;
              width: auto;
              object-fit: contain;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              page-break-inside: avoid;
            }
            th, td {
              padding: 2px 4px;
              border: 1px solid transparent;
            }
            th {
              font-weight: bold;
            }
            .items-table th, .items-table td {
              padding: 2px 3px;
            }
            .ft-9 {
              font-size: 9px;
            }
            .ft-10 {
              font-size: 10px;
            }
            .ft-11 {
              font-size: 11px;
            }
            @media print {
              .gen-lab-rep-print {
                background: white !important;
                height: auto !important;
                min-height: auto !important;
              }
            }
          `}
        </style>

        {/* Header avec logo */}
        <div className="header-flex">
          <div className="header-logo">
            {logo && (
              <img 
                src={logo} 
                alt="Logo" 
                onError={(e) => {
                  console.error('Erreur chargement logo')
                  e.target.style.display = 'none'
                }}
              />
            )}
          </div>
        </div>

        {/* Hospital Info */}
        <div className="text-center m-0" style={{ borderBottom: '1px solid black' }}>
          <div className="d-flex gap-2 justify-content-center m-0 align-items-center">
            <Col>
              <h5
                style={{
                  color: '#d13e6a',
                  fontWeight: '700',
                  margin: '0',
                  padding: '0',
                }}
              >
                {t('hospital_name')}
              </h5>
              <h6
                className="ft-10"
                style={{ color: '#45a049', fontWeight: '500', margin: 0 }}
              >
                {t('hospital_location')}
              </h6>
            </Col>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <span className="ft-9" style={{ margin: 0 }}>
              {t('hospital_email')}
            </span>
            <span className="ft-9" style={{ margin: 0 }}>
              {t('hospital_contact')}
            </span>
          </div>
        </div>

        {/* Section Vente */}
        {props.section === 'sale' ? (
          <>
            {/* Infos patient */}
            <div className="m-0" style={{ borderBottom: '2px solid black' }}>
              <table className="table table-borderless m-0" style={{ background: 'none' }}>
                <tbody className="ft-10" style={{ borderTop: '1px solid black', background: 'none' }}>
                  <tr style={{ background: 'none' }}>
                    <th style={{ width: '10%', background: 'none' }}>{t('bill_no')}</th>
                    <td style={{ background: 'none' }}>{props.sale?.orderRef || 'N/A'}</td>

                    <th style={{ background: 'none' }}>{t('patient_id')}</th>
                    <td style={{ background: 'none' }}>
                      {props.sale?.patient?.patientRef || 'N/A'}
                    </td>

                    <th style={{ background: 'none' }}>{t('date')}</th>
                    <td style={{ background: 'none' }}>
                      {props.paymentDate
                        ? moment(props.paymentDate).format('DD / MM / YYYY')
                        : props.sale?.orderDate
                        ? moment(props.sale.orderDate).format('DD / MM / YYYY')
                        : moment().format('DD / MM / YYYY')}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ width: '14%', background: 'none' }}>{t('patient_name')}</th>
                    <td style={{ background: 'none' }}>
                      {props.sale?.patient
                        ? `${props.sale.patient.firstName || ''} ${props.sale.patient.lastName || ''}`.trim() || 'N/A'
                        : 'N/A'}
                    </td>

                    <th style={{ background: 'none' }}>{t('gender')}</th>
                    <td style={{ background: 'none' }}>
                      {props.sale?.patient?.gender === 'M'
                        ? t('male')
                        : props.sale?.patient?.gender === 'F'
                        ? t('female')
                        : 'N/A'}
                    </td>
                    
                    <th style={{ background: 'none' }}>{t('address')}</th>
                    <td style={{ background: 'none' }}>
                      {[
                        props.sale?.patient?.address?.address,
                        props.sale?.patient?.address?.city,
                        props.sale?.patient?.address?.region
                      ].filter(Boolean).join(', ') || 'N/A'}
                    </td>
                  </tr>

                  {props.sale?.patientRecord?.bedRecords && (
                    <tr>
                      <th>{t('bed_no')}</th>
                      <td>VIP 02</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Items Table */}
            <div className="m-0">
              <table className="table table-borderless fw-bold ft-11 items-table">
                <thead>
                  <tr>
                    <th style={{ width: '10%' }}>{t('s_no')}</th>
                    <th style={{ width: '60%' }}>{t('ipd_service_details')}</th>
                    <th style={{ width: '10%' }}>{t('qty')}</th>
                    <th style={{ width: '10%' }}>{t('rate')}</th>
                    <th style={{ width: '10%' }}>{t('discount')}</th>
                    <th style={{ width: '10%' }}>{t('amount')}</th>
                  </tr>
                </thead>
                
                <tbody>
                  {props.items && props.items.length > 0 ? (
                    props.items.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.label || row.product?.name || 'N/A'}</td>
                        <td>{row.quantity || 0}</td>
                        <td>{row.unitPrice || 0}</td>
                        <td>{row.discount || 0}</td>
                        <td>{row.rowTotal || row.finalPrice || 0}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">Aucun article</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Totals */}
            <div className="m-0" style={{ borderBottom: '1px solid black', borderTop:'1px solid black' }}>
              <table className="table table-borderless m-0">
                <tbody>
                  <tr style={{ borderTop: '1px solid black' }}>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <b>{t('total_amount')} :</b>
                    </td>
                    <td>{props.totalAmount || 0}</td>

                    <td style={{ whiteSpace: 'nowrap' }}>
                      <b>{t('amount_recieved')} :</b>
                    </td>
                    <td>{props.amountRecieved || 0}</td>

                    <td style={{ whiteSpace: 'nowrap' }}>
                      <b>{t('amount_return')} :</b>
                    </td>
                    <td>
                      {(props.amountRecieved || 0) > (props.totalAmount || 0)
                        ? (props.amountRecieved || 0) - (props.totalAmount || 0)
                        : 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="text-center p-5">
            <p style={{ color: 'red', fontSize: '16px' }}>
              ⚠️ Section non définie ou invalide. Props.section = "{props.section}"
            </p>
            <p>Veuillez passer section="sale" en props.</p>
          </div>
        )}

        {/* Footer */}
        <div className="text-center">
          <p className="fw-bold m-0 p-0 ft-9" style={{ color: '#d13e6a' }}>
            {t('slogan')}
          </p>
          <p className="fw-bold text-danger m-0 p-0 ft-9">
            {t('invoice_footer')}:
            <span className="text-primary ft-9"> +237 6 75 55 38 64</span>
          </p>
        </div>
      </div>
    )
  } catch (error) {
    console.error('ERREUR CRITIQUE dans GeneralCashierContent:', error)
    return (
      <div style={{ padding: '20px', color: 'red', border: '2px solid red' }}>
        <h3>❌ ERREUR DE RENDU</h3>
        <p><strong>Message:</strong> {error.message}</p>
        <p><strong>Stack:</strong></p>
        <pre style={{ fontSize: '10px', overflow: 'auto' }}>{error.stack}</pre>
      </div>
    )
  }
}

export default withRouter(withTranslation()(GeneralCashierContent))